import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';

declare var swal: any;

@Injectable()
export class AdminSystemUserGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (!this.authService.isSuperAdminAdminEditor()) {
      swal('Unauthorized Access!!!.', 'Please Login as Admin', 'error');
      this.router.navigate(['/auth/login']);
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/admin-system-user-guard.service.ts